import { FormattedMessage } from 'react-intl'

import { useMessage } from './hooks'

const Text = ({ className = '', id = '', values = {}, ...restOfProps }) => {
  const croppedId = useMessage(id)

  if (!croppedId) {
    return null
  }

  return (
    <span className={className}>
      <FormattedMessage id={croppedId} values={{ ...values, ...restOfProps }} />
    </span>
  )
}

export default Text
